import api from '../../api';
import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import NextAwayMatchForm from './NextAwayMatchForm';
import NextAwayMatchTable from './NextAwayMatchTable';

const EMPTY_FORM = {
  date: '',
  matchHours: '',
  placeName: '',
  placeAddress: '',
  vsTeam: '',
  torneo: '',
};

const NextAwayMatch = () => {
  const [nextAwayMatches, setNextAwayMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formDataNextAwayMatch, setFormDataNextAwayMatch] = useState(EMPTY_FORM);

  const fetchNextAwayMatches = async () => {
    setLoading(true);
    try {
      const response = await api.get('/nextAwayMatches');
      setNextAwayMatches(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNextAwayMatches();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/nextAwayMatch/${id}`);
      fetchNextAwayMatches();
    } catch (error) {
      console.error('Error deleting away match:', error);
    }
  };

  const handleEdit = async (updatedMatch) => {
    try {
      await api.put(`/nextAwayMatch/${updatedMatch.id}`, updatedMatch);
      fetchNextAwayMatches();
    } catch (error) {
      console.error('Error editing away match:', error);
    }
  };

  const handleInputChangeNextAwayMatch = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormDataNextAwayMatch({
      ...formDataNextAwayMatch,
      [event.target.name]: value,
    });
  };

  const handleFormNextAwayMatchSubmit = async (event) => {
    event.preventDefault();
    await api.post('/nextAwayMatch', formDataNextAwayMatch);
    fetchNextAwayMatches();
    setFormDataNextAwayMatch(EMPTY_FORM);
  };

  return (
    <div className="container">
      <NextAwayMatchForm
        formDataNextAwayMatch={formDataNextAwayMatch}
        onInputChange={handleInputChangeNextAwayMatch}
        onSubmit={handleFormNextAwayMatchSubmit}
      />
      <div style={{ height: '80px' }}></div>
      {loading ? <LoadingSpinner /> : (
        <NextAwayMatchTable
          nextAwayMatches={nextAwayMatches}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      )}
    </div>
  );
};

export default NextAwayMatch;
